import axios from "../../utils/axios";

const apiUrl = process.env.REACT_APP_HS_API_URL;

// Backend returns `Ok(byte[])`, which Newtonsoft serializes as a base64 JSON string.
const createQRCode = (url) => {
    return axios.get<string>(`${apiUrl}/action/qrcode`, { params: { url } })
};

const qrCodeService = { 
  createQRCode,
};

export default qrCodeService;
